import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {EiStructureDto} from "../../../model/dto/entity/ei-structure.dto";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {ConfirmationService} from "primeng/api";
import {ObserverService} from "../../../../../core/shared/object/service/observer.service";
import {NavigationItem} from "../../../../../core/shared/dto/navigation/navigation-item";


@Component({
    selector: 'mvs-ei-structure-object',
    templateUrl: './ei-structure-object.component.html',
    styleUrls: ['./ei-structure-object.component.scss'],
    standalone: false
})
export class EiStructureObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    dto: EiStructureDto;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onObjectChanged() {
        this.setPageTitle(this.dto?.['name']);
    }

    handleNavigationItems(navigationItems: NavigationItem[]): void {
        this.onNavigationItems.emit(navigationItems);
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
